import { render, staticRenderFns } from "./DesignCosts.vue?vue&type=template&id=3b616701&scoped=true&"
import script from "./DesignCosts.vue?vue&type=script&lang=js&"
export * from "./DesignCosts.vue?vue&type=script&lang=js&"
import style0 from "./DesignCosts.vue?vue&type=style&index=0&id=3b616701&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b616701",
  null
  
)

export default component.exports